module.exports = __webpack_public_path__ + "img/local_shipping_outlined.6b30be4a.svg";